import React from 'react';

import { compose, isEmpty, map, reject, split, trim } from 'lodash/fp';

import Input from './Input';

type Props = {
    value?: string[] | null;
    onChange: (ev: any) => void;
};

type State = {
    value: string;
};

const formatValue = compose(reject(isEmpty), map(trim), split(','));

class CsvInput2 extends React.PureComponent<Props, State> {
    state = {
        value: this.props.value ? this.props.value.join(', ') : '',
    };

    componentDidUpdate(prevProps) {
        const { value } = this.props;
        if (value !== null && value !== prevProps.value) {
            this.setState({
                value: this.props.value.join(', '),
            });
        }
    }

    handleChange = (ev) => this.setState({ value: ev.target.value });

    handleSave = (ev) => {
        const name = ev.target.name;
        const value = formatValue(ev.target.value);

        this.props.onChange({
            target: { name, value },
        });
    };

    render() {
        return (
            <Input
                {...this.props}
                type="text"
                value={this.state.value}
                onChange={this.handleChange}
                onBlur={this.handleSave}
            />
        );
    }
}

export default CsvInput2;
